export default __webpack_public_path__ + "static/media/not-found-cone.ff86bfc7.svg";